import { render, staticRenderFns } from "./Banner1.vue?vue&type=template&id=bfbd57fc&scoped=true&"
import script from "./Banner1.vue?vue&type=script&lang=js&"
export * from "./Banner1.vue?vue&type=script&lang=js&"
import style0 from "./Banner1.vue?vue&type=style&index=0&id=bfbd57fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbd57fc",
  null
  
)

export default component.exports